import { NO_PENDING } from './useThrottledState.constants'

export function isThrottledStatePending(value) {
  return value !== NO_PENDING
}
